import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid } from '@material-ui/core';
import { connect } from 'react-redux';

import { useStyles } from './TablePaginationElementUseStyles';

const TablePaginationElement = props => {
  const {
    rowsPerPageOptions,
    wholeDataLength,
    labelRowsPerPage,
    language,
    tableRowsPerPage,
    tablePaginationNumber,
    handleChangePage,
    handleChangeRowsPerPage,
    drones,
  } = props;
  const classes = useStyles();

  return (
    <Grid
      item
      className={clsx({
        [`${classes.TablePaginationElement}__container`]: drones === false,
      })}
    >
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={wholeDataLength || 0}
        labelRowsPerPage={
          labelRowsPerPage || language.missionsDetails.rowsPerPage_
        }
        labelDisplayedRows={
          ({ from, to, count }) =>
            `${from}-${to} ${language.tables.expression_} 
            ${count !== -1 ? count : `${language.tables.moreThan_}${to}`}`
          // eslint-disable-next-line react/jsx-curly-newline
        }
        rowsPerPage={tableRowsPerPage || 0}
        page={tablePaginationNumber || 0}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        className={`${classes.TablePaginationElement}__tabel-pagination--font-size`}
        classes={{
          input: `${classes.TablePaginationElement}__tabel-pagination--font-size`,
          caption: `${classes.TablePaginationElement}__tabel-pagination--font-size`,
          selectRoot: `${classes.TablePaginationElement}__tabel-pagination--margin--right`,
          actions: `${classes.TablePaginationElement}__tabel-pagination--margin--left`,
          toolbar: `${classes.TablePaginationElement}__tabel-pagination--padding ${classes.TablePaginationElement}__tabel-pagination--color`,
        }}
        SelectProps={{
          classes: {
            icon: `${classes.TablePaginationElement}__tabel-pagination--margin-top`,
            select: `${classes.TablePaginationElement}__tabel-pagination--padding ${classes.TablePaginationElement}__tabel-pagination--color`,
          },
        }}
      />
    </Grid>
  );
};

TablePaginationElement.propTypes = {
  language: PropTypes.object,
  rowsPerPageOptions: PropTypes.array,
  wholeDataLength: PropTypes.number,
  labelRowsPerPage: PropTypes.string,
  tableRowsPerPage: PropTypes.number,
  tablePaginationNumber: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  drones: PropTypes.bool,
};
const mapStateToProps = state => ({
  language: state.language,
  timezone: state.timezone,
  map: state.map,
});
export default connect(mapStateToProps)(TablePaginationElement);
